import React, { useState } from "react";

import Sidebar from "../components/Sidebar";
import PageHeader from "../components/common/PageHeader";
import DashboardTebularComponent from "../components/DashboardTebularComponent";
const DashboardTebular = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return (
    <div>
      <div className="flex min-h-screen bg-white text-gray-700">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="flex-1 ml-[250px] p-6 overflow-y-auto">
          <PageHeader
            title="Dashboard (Tabular View of Proposals)"
            onMenuClick={() => setSidebarOpen(true)}
          />
          <DashboardTebularComponent />
        </main>
      </div>
    </div>
  );
};

export default DashboardTebular;
